import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { StudyState } from './state/study/study.reducer';
import { selectIsSideNavOpen, selectSelectedStudy } from './state/study/study.selectors';
import { Observable, Subscription } from 'rxjs';
import { Study } from '../models/study';
import { StudyType } from '../models/study-type';
import { MatSidenavContainer } from '@angular/material/sidenav';

@Component({
  selector: 'dashboard-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSidenavContainer) sidenavContainer: MatSidenavContainer;

  isSideNavOpen$: Observable<boolean>;
  selectedStudy$: Observable<Study>;

  StudyType = StudyType;

  private subscriptions$ = new Subscription();

  constructor(private store: Store<StudyState>) {}

  ngOnInit(): void {
    this.isSideNavOpen$ = this.store.select(selectIsSideNavOpen);
    this.selectedStudy$ = this.store.select(selectSelectedStudy);
  }
  ngAfterViewInit(): void {
    // Added because the virtual scroll (scroll.window) does not work well with mat sidenav
    this.subscriptions$.add(
      this.sidenavContainer.scrollable.elementScrolled().subscribe(() => window.dispatchEvent(new Event('resize')))
    );
  }
  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
